export enum PaymentMethod {
  WALLET = 'wallet',
  EXCHANGE = 'exchange',
}
